import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class customerExplorerPolicy extends BasePolicy {
  static canView() {
    const roles = [
      Roles.SELLER,
      Roles.SUB_MANAGER,
      Roles.MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.SUPER_USER,
    ];

    const channels = [Channels.WHOLESALER, Channels.RETAIL];
    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
